import { hasPermission, PERMISSIONS } from '@/lib/permissions'

const STORAGE_PREFIX = 'salon_desk_onboarding_v1_'

/**
 * @param {number | string} userId
 */
export function onboardingStorageKey(userId) {
  return `${STORAGE_PREFIX}${userId}`
}

/**
 * @param {number | string} userId
 * @returns {'done' | 'skipped' | null}
 */
export function getOnboardingState(userId) {
  try {
    const value = localStorage.getItem(onboardingStorageKey(userId))
    if (value === 'done' || value === 'skipped') {
      return value
    }
  } catch {
    // ignore
  }
  return null
}

/**
 * @param {number | string} userId
 * @param {'done' | 'skipped'} state
 */
export function setOnboardingState(userId, state) {
  try {
    localStorage.setItem(onboardingStorageKey(userId), state)
  } catch {
    // ignore
  }
}

/**
 * @param {import('@/types/api').AuthUser | null | undefined} user
 * @param {{ serviceCount: number, staffCount: number }} counts
 */
export function shouldPromptOnboarding(user, counts) {
  if (!user?.id || !hasPermission(user, PERMISSIONS.ADMIN_FULL)) {
    return false
  }

  const existing = getOnboardingState(user.id)
  if (existing === 'done' || existing === 'skipped') {
    return false
  }

  if (counts.serviceCount >= 3 && counts.staffCount >= 1) {
    setOnboardingState(user.id, 'done')
    return false
  }

  return true
}
